import { useEffect, useState } from 'react'

import type { CogoSyncSnapshot } from './cogoSyncWorker'

/** Subscribe to order Collect&Go sync SSE; keeps latest snapshot. */
export function useCogoSyncEvents(orderId: number, enabled = true) {
  const [job, setJob] = useState<CogoSyncSnapshot | null>(null)

  useEffect(() => {
    if (!enabled || !orderId) return

    let cancelled = false
    void fetch(`/api/orders/${orderId}/cogo-sync`, { credentials: 'include' })
      .then((r) => r.json())
      .then((data) => {
        if (!cancelled && data.job) setJob(data.job)
      })
      .catch(() => {})

    const es = new EventSource(`/api/orders/${orderId}/cogo-sync/events`, {
      withCredentials: true,
    })

    es.addEventListener('snapshot', (ev) => {
      try {
        const data = JSON.parse(
          (ev as MessageEvent).data
        ) as CogoSyncSnapshot | null
        setJob(data)
      } catch {
        /* ignore */
      }
    })

    es.addEventListener('sync', (ev) => {
      try {
        const data = JSON.parse((ev as MessageEvent).data) as CogoSyncSnapshot
        setJob(data)
      } catch {
        /* ignore */
      }
    })

    es.onerror = () => {
      // EventSource reconnects automatically
    }

    return () => {
      cancelled = true
      es.close()
    }
  }, [enabled, orderId])

  return job
}
